<p-button
  [icon]="isLoading() ? 'pi pi-spin pi-spinner' : 'pi pi-headphones'"
  [label]="label()"
  severity="success"
  [size]="size()"
  [outlined]="outlined()"
  [disabled]="isLoading() || !agentId() || !sessionId()"
  (click)="open()">
</p-button>
